export default function UsersRouteConfig($stateProvider, gettext) {
  'ngInject';

  let profileEdit = gettext('Edit Profile'),
    profileSub = gettext('Subscriptions');

  $stateProvider
    .state('users', {
      url: '/users',
      template: `<profile-user></profile-user>`,
      redirectTo: 'users.profile',
      ncyBreadcrumb: {
        label: "{{'Profile' | translate}}"
      },
      requiredFeatures: ['profile']
    })
    .state('users.profile', {
      url: '/profile',
      template: require('./edit-profile/editProfile.html'),
      redirectTo: 'users.profile.personal',
      ncyBreadcrumb: {
        label: "{{'Edit Profile' | translate}}"
      }
    })
    .state('users.profile.personal', {
      url: '/personal',
      helpModuleId: 'profile',
      helpState: 'users.profile.personal',
      template: require('./edit-profile/info/info.html'),
      ncyBreadcrumb: {
        skip: true
      }
    })
    .state('users.profile.changePassword', {
      url: '/changePassword',
      helpModuleId: 'profile',
      helpState: 'users.profile.changePassword',
      template: require('./edit-profile/password/password.html'),
      ncyBreadcrumb: {
        skip: true
      }
    })
    .state('users.profile.changeEmail', {
      url: '/changeEmail',
      helpModuleId: 'profile',
      helpState: 'users.profile.changeEmail',
      template: require('./edit-profile/email/email.html'),
      ncyBreadcrumb: {
        skip: true
      }
    })
    .state('users.subscriptions', {
      url: '/subscriptions',
      helpModuleId: 'profile',
      helpState: 'users.subscriptions',
      template: require('./subscriptions/subscriptions.html'),
      controller: 'ProfileSubscriptionsController',
      ncyBreadcrumb: {
        label: "{{'Subscriptions' | translate}}"
      },
      requiresChangeEmail: true
    });
}
